import { currency, makeDomElement } from '../utils'

const sortBookies = (obj, by, desc, firstLevel) => {
  var sorted = {}

  Object.keys(obj)
    .sort((a, b) => {
      if (firstLevel) {
        return desc
          ? obj[b][firstLevel][by] - obj[a][firstLevel][by]
          : obj[a][firstLevel][by] - obj[b][firstLevel][by]
      }

      return desc ? obj[b][by] - obj[a][by] : obj[a][by] - obj[b][by]
    })
    .forEach(key => { sorted[key] = obj[key] })

  return sorted
}

const makeLogo = (name, logoUrl) => {
  const image = makeDomElement('img')
  image.src = logoUrl
  image.alt = `${name} logo`
  image.width = '220'
  image.height = '60'

  const span = makeDomElement('span', null, 'bookie')
  span.appendChild(image)

  return span
}

const makeButton = (url, name) => {
  const link = makeDomElement('a', 'Claim Bonus', 'bonusLink')
  link.href = url
  link.rel = 'nofollow noopener'
  link.setAttribute('title', `Claim Bonus, Sportsbook: ${name}`)

  return link
}

const makeBonus = (bonus) => {
  const bonusEl = makeDomElement('span', null, 'bonus')
  bonusEl.appendChild(makeDomElement('span', `${bonus.percentage}%`, 'percentage'))
  if (bonus.upperLimit) {
    bonusEl.appendChild(makeDomElement('span', `<span class="hidden md:inline">Bonus</span> Up To`, 'upTo'))
    bonusEl.appendChild(makeDomElement('span', `${currency(bonus.upperLimit)}`, 'upperLimit'))
  }
  bonusEl.appendChild(makeDomElement('span', bonus.additional || '', 'additional'))

  return bonusEl
}

const makeList = (bookieList, market = 'sports') => {
  const listEl = makeDomElement('ol')
  listEl.setAttribute('aria-label', 'Sportsbooks Table')

  Object.keys(bookieList).forEach((key, index) => {
    if (market in bookieList[key]) {

      const bookie = bookieList[key]

      const li = makeDomElement('li')
      li.dataset.bookie = key

      li.appendChild(makeDomElement('span', index + 1, 'order'))
      li.appendChild(makeLogo(key, bookie.logoUrl))
      li.appendChild(makeBonus(bookie[market]))

      const rollover = `<span class="inline sm:hidden text-sm">Rollover:</span> ${bookie[market].rollover}X`
      li.appendChild(makeDomElement('span', rollover, 'rollover'))

      const minDeposit = `<span class="inline sm:hidden text-sm">Min Deposit:</span> ${bookie[market].minDeposit ? currency(bookie[market].minDeposit) : 'N/A'}`
      li.appendChild(makeDomElement('span', minDeposit, 'minDeposit'))

      const bonusCode = `<span class="inline sm:hidden text-sm">Bonus Code:</span> ${bookie[market].code || 'N/A'}`
      li.appendChild(makeDomElement('span', bonusCode, 'code'))

      li.appendChild(makeButton(bookie.affLink, key))

      listEl.appendChild(li)
    }
  })

  return listEl
}

const createBookieListEl = (bookies, orderBy, descending, market) => {
  // first filter items by market (some they have sports offer or casino offer, etc.)
  const filtered = Object.fromEntries(Object.entries(bookies)
    .filter(([key, value]) => value[market] !== undefined))
  // sort the list by given attributes
  const sorted = sortBookies(filtered, orderBy, descending, market)
  return makeList(sorted, market || 'sports')
}

export { createBookieListEl }
